// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsLetter_container__2puZs","wrapper":"NewsLetter_wrapper__cp5HM"};